/* eslint-disable no-param-reassign */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, { useEffect, useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';

import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  quarterFormatter,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  compareTwoDatesGreaterThanOrEqual,
  getDateInMMDDYYYYFormat,
  getUTCTimeStampMMDDYYYY,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import * as errorConstant from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  manuFactureHead,
  manuFactureHeadRecordMailing,
} from '../../../../SharedModules/Table/tableHead';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import {
  calculateRecordMailingDate,
  getManufacturersByPQR,
  getMaxQuarterForFreezeDt,
  getRebateProgramCode,
  setReqRecordMailingData,
  setErrorMessages,
} from '../Store/actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  getPlanTypeRadioBoxValue,
  getRebateProgramDropdownList,
} from '../../../Research/UnderThresholdInvoices/store/Actions';
import {
  MinDate,
  radioGroupLabelNamePlan,
} from '../../../../SharedModules/CommonConstants/commonConstants';

function RecordMailingDate() {
  const dispatch = useDispatch();
  // const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupSuccess, setShowPopupSuccess] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [headerHeight, setHeaderHeight] = useState(45);
  const [selRowIndex, setSelRowIndex] = useState(-1);
  const [mailingDate, setMailingDate] = useState(new Date());
  const [enteredInvoiceNum, setEnteredInvoiceNum] = useState('');
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);

  const defaultQtrRMD = useSelector(
    (state) => state.sharedState.RecordMailingDateReducer?.defaultQtrRMD?.data
  );

  const manufacturersByPQR = useSelector(
    (state) => state.sharedState.RecordMailingDateReducer?.manufacturersByPQR
  );
  const reqRecordMailingData = useSelector(
    (state) => state.sharedState.RecordMailingDateReducer?.reqRecordMailingData
  );

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const saveOrUpdateMessage = useSelector(
    (state) => state.sharedState.RecordMailingDateReducer?.recordMailingData
  );

  const errorMessages = useSelector(
    (state) => state.sharedState.RecordMailingDateReducer?.errorMessages
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const getRowStyle = (params) => {
    if (successMessages?.length > 0 && params?.rowIndex === selRowIndex) {
      return { background: 'yellow' };
    }
  };
  // set common dropdown list after calling API service
  React.useEffect(() => {
    if (reqRecordMailingData?.planType) {
      getRebateProgramDropdownList(reqRecordMailingData?.planType).then(
        (res) => {
          let list = [];
          if (
            res?.status === constantMessageData.STATUS_MSG &&
            res?.message === constantMessageData.SUCCESS_MSG
          ) {
            if (!_.isEmpty(res.data)) {
              list = _.map(res.data, (val) => ({
                ...val,
                id: val.rebateProgramCd,
                name: `${val.rebateProgramCd} | ${val.shortDescr}`,
              }));
            }
          }
          setRebateProgramList(
            list.sort((key, val) =>
              key.name.toLowerCase().localeCompare(val.name.toLowerCase())
            )
          );
        }
      );
    }
  }, [reqRecordMailingData?.planType]);
  // set play type Radio Data List for page load
  React.useEffect(() => {
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
    handleScrollToEvent();
  }, []);
  React.useEffect(() => {
    if (reqRecordMailingData.defInvoiceSelectModeCd === undefined) {
      dispatch(
        setReqRecordMailingData({
          ...reqRecordMailingData,
          defInvoiceSelectModeCd: 'PQM',
        })
      );
    }
  }, [reqRecordMailingData.defInvoiceSelectModeCd === undefined]);
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessages && errorMessages.length > 0) {
      tabHighLigther('/recordMailingDate', true);
    } else {
      tabHighLigther('/recordMailingDate', false);
    }
  }, [JSON.stringify(errorMessages)]);

  const isNumber = (evt) => {
    evt = evt || window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      // handleErrorMessages(['Invalid Invoice Number']);
      return false;
    }
    return true;
  };

  useEffect(() => {
    setSuccessMessages([]);
    setSelRowIndex(-1);
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(
      setReqRecordMailingData({
        ...reqRecordMailingData,
        qtr:
          reqRecordMailingData?.qtr == null
            ? defaultQtrRMD
            : reqRecordMailingData?.qtr,
        defInvoiceSelectModeCd: UserDefaultValues?.defInvoiceSelectModeCd
          ? UserDefaultValues?.defInvoiceSelectModeCd
          : reqRecordMailingData?.defInvoiceSelectModeCd,

        planType: !reqRecordMailingData?.planType
          ? UserDefaultValues?.planTypeCd
          : reqRecordMailingData?.planType,
        rebateProgramCd: !reqRecordMailingData?.rebateProgramCd
          ? UserDefaultValues?.rebateProgramCd
          : reqRecordMailingData?.rebateProgramCd,
      })
    );
  }, [UserDefaultValues]);

  useEffect(() => {
    if (successMessages?.length > 0) {
      if (headerHeight == 45) setHeaderHeight(headerHeight + 1);
      else setHeaderHeight(headerHeight - 1);
    }
  }, [successMessages]);

  useEffect(() => {
    if (defaultQtrRMD) {
      dispatch(
        setReqRecordMailingData({
          ...reqRecordMailingData,
          qtr:
            reqRecordMailingData?.qtr == null
              ? defaultQtrRMD
              : reqRecordMailingData?.qtr,
          defInvoiceSelectModeCd:
            reqRecordMailingData?.defInvoiceSelectModeCd === ''
              ? UserDefaultValues?.defInvoiceSelectModeCd
              : reqRecordMailingData?.defInvoiceSelectModeCd,
          planType:
            reqRecordMailingData?.planType === ''
              ? UserDefaultValues?.planTypeCd
              : reqRecordMailingData?.planType,
          rebateProgramCd: !reqRecordMailingData?.rebateProgramCd
            ? UserDefaultValues?.rebateProgramCd
            : reqRecordMailingData?.rebateProgramCd,
        })
      );
    }
  }, [defaultQtrRMD]);

  useEffect(() => {
    // setSpinnerLoader(false);
    setSuccessMessages([]);
    let successMsg = '';
    if (reqRecordMailingData.defInvoiceSelectModeCd === 'IN') {
      successMsg = `${CONSTANTS.MAILING_DT_SUCCESS_INV}'${reqRecordMailingData?.invoiceNum}'`;
    } else {
      successMsg = CONSTANTS.MAILING_DT_SUCCESS;
    }
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCESS') {
      const msg = getSuccessNotificationMsg(
        successMsg,
        saveOrUpdateMessage.data
      );
      setSuccessMessages([msg]);
      setShowPopupSuccess(false);
    } else if (saveOrUpdateMessage?.error === 'API failed') {
      dispatch(
        setErrorMessages([
          {
            field: 'resultNotFound2',
            errorType: 'resultNotFound2',
            message: CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
    } else if (saveOrUpdateMessage && saveOrUpdateMessage?.message) {
      // if (reqRecordMailingData.defInvoiceSelectModeCd === 'PQM') {
      if (saveOrUpdateMessage?.message?.includes('Value must not be null')) {
        dispatch(
          setErrorMessages([
            {
              field: 'resultNotFound2',
              errorType: 'resultNotFound2',
              message: CONSTANTS.NO_MFG_CHOSEN_ERR,
            },
          ])
        );
      }
      // }
      else if (saveOrUpdateMessage?.message?.includes('Not found')) {
        dispatch(
          setErrorMessages([
            {
              field: 'InvNumNotFrozen',
              errorType: 'invoiceNum',
              message: `${CONSTANTS.INVOICE_NOT_FOUND}. Invoice: #${enteredInvoiceNum}`,
            },
          ])
        );
      } else if (saveOrUpdateMessage?.message.includes('is yet to be')) {
        dispatch(
          setErrorMessages([
            {
              field: 'InvNumNotFrozen',
              errorType: 'invoiceNum',
              message: saveOrUpdateMessage?.message,
            },
          ])
        );
      } else if (
        saveOrUpdateMessage?.message?.includes(
          'This Invoice already has a mailing date'
        )
      ) {
        setPopupMessage(saveOrUpdateMessage?.message);
        setShowPopup(true);
      } else {
        dispatch(
          setErrorMessages([
            {
              field: 'resultNotFound2',
              errorType: 'resultNotFound2',
              message: saveOrUpdateMessage?.message,
            },
          ])
        );
      }
    }
  }, [saveOrUpdateMessage]);

  const onCellClicked = (e) => {
    setSelRowIndex(e.rowIndex);
    setSelected([e.data.mfgId]);
  };

  const getSuccessNotificationMsg = (msg, data) => {
    let noOfInvoices = 0;
    if (data) {
      noOfInvoices =
        data?.split(' ').length > 0 ? data?.split(' ')[1] : noOfInvoices;
    }
    return msg
      .replace('#', noOfInvoices)
      .replace('Quarter', `Quarter ${reqRecordMailingData.qtr}`);
  };

  const validateInvoiceCalcReq = () => {
    setSuccessMessages([]);

    let localErr = [];
    let showError = false;
    if (
      reqRecordMailingData.mailingDate === null ||
      reqRecordMailingData.mailingDate === ''
    ) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'dateFormatInvalid' &&
          item.field !== 'compareDateGreater' &&
          item.field !== 'notSelectedMFG'
        );
      });
      showError = true;
      localErr.push({
        field: 'mailingDateRequired',
        errorType: 'mailingDate',
        message: constantMessageData.FREEZE_DT_REQ,
      });
    } else if (
      reqRecordMailingData.mailingDate &&
      validDate(new Date(reqRecordMailingData.mailingDate)) === false
    ) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'compareDateGreater' &&
          item.field !== 'mailingDateRequired' &&
          item.field !== 'notSelectedMFG'
        );
      });
      showError = true;
      localErr.push({
        field: 'dateFormamailingDateRequiredtInvalid',
        errorType: 'mailingDate',
        message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
      });
    } else if (
      reqRecordMailingData.mailingDate &&
      compareTwoDatesGreaterThanOrEqual(
        reqRecordMailingData.mailingDate,
        moment(MinDate)
      )
    ) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'dateFormatInvalid' &&
          item.field !== '' &&
          item.field !== 'notSelectedMFG'
        );
      });
      showError = true;
      localErr.push({
        field: 'compareDateGreater',
        errorType: 'mailingDate',
        message: constantMessageData.MINIMUM_MAILING_DT,
      });
    }
    if (!showError) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'dateFormatInvalid' &&
          item.field !== 'compareDateGreater' &&
          item.field !== 'mailingDateRequired' &&
          item.field !== 'notSelectedMFG'
        );
      });
    }

    if (reqRecordMailingData.defInvoiceSelectModeCd === 'PQM') {
      if (
        reqRecordMailingData.rebateProgramCd === '' ||
        reqRecordMailingData.rebateProgramCd === undefined
      ) {
        localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      }
      if (reqRecordMailingData.qtr === '') {
        localErr = localErr.filter(
          (item) => item.field !== 'qtr' && item.filed !== 'resultNotFound2'
        );
        localErr.push({
          field: 'qtr',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      } else if (!checkQuarterValidation(reqRecordMailingData.qtr)) {
        localErr = localErr.filter(
          (item) => item.field !== 'qtr' && item.filed !== 'resultNotFound2'
        );
        localErr.push({
          field: 'qtr',
          errorType: 'invalidFormat',
          message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
        });
      }
    } else if (
      reqRecordMailingData?.invoiceNum === null ||
      reqRecordMailingData?.invoiceNum === ''
    ) {
      localErr.push({
        field: 'resultNotFound1',
        errorType: 'invoiceNum',
        message: constantMessageData.INVOICE_NUM_REQ,
      });
    }

    dispatch(setErrorMessages([...new Set(localErr)]));
    return !localErr.length > 0;
  };

  const serverTimezoneDate = (date) => {
    return getUTCTimeStampMMDDYYYY(date);
  };

  const handleDate = (e, isDate) => {
    setSuccessMessages([]);

    if (isDate === 'mailingDate') {
      dispatch(
        setReqRecordMailingData({
          ...reqRecordMailingData,
          mailingDate: e ? serverTimezoneDate(e) : null,
        })
      );
      setMailingDate(e ? serverTimezoneDate(e) : null);
    }
  };

  const handlereqRecordMailingData = (e) => {
    setErrorMessages([]);
    setSuccessMessages([]);
    dispatch(setErrorMessages([]));

    if (e.target.name === 'forAllMfg') {
      dispatch(
        setReqRecordMailingData({
          ...reqRecordMailingData,
          [e.target.name]: e.target.checked,
        })
      );
    } else {
      dispatch(
        setReqRecordMailingData({
          ...reqRecordMailingData,
          [e.target.name]: e.target?.value?.toUpperCase(),
          ...('planType' in reqRecordMailingData &&
            e.target.name === 'planType' && { rebateProgramCd: '-1' }),
        })
      );
      if (e.target.name === 'invoiceNum') {
        setEnteredInvoiceNum(e.target.value);
      }
    }
  };

  const searchManufacturers = async () => {
    let localErr = [];
    let showError = false;
    if (validateInvoiceCalcReq()) {
      const payload = {
        mfgTypeCd:
          reqRecordMailingData?.planType === 'FD' ||
          reqRecordMailingData?.planType === 'FD'
            ? 'G'
            : 'C',
        qtr: reqRecordMailingData?.qtr,
        retainPrintQtr: reqRecordMailingData?.qtr,
        rebateProgramCd: reqRecordMailingData?.rebateProgramCd,
      };
      try {
        const response = await dispatch(getManufacturersByPQR(payload));
        if ((response && response.length === 0) || response == undefined) {
          dispatch(
            setErrorMessages([
              {
                field: 'resultNotFound2',
                errorType: 'resultNotFound2',
                message: 'No results found',
              },
            ])
          );
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const processRecordMailingDate = () => {
    if (validateInvoiceCalcReq()) {
      if (reqRecordMailingData.defInvoiceSelectModeCd === 'PQM') {
        if (!reqRecordMailingData.forAllMfg && selected === null) {
          dispatch(
            setErrorMessages([
              {
                field: 'resultNotFound2',
                errorType: 'resultNotFound2',
                message: CONSTANTS.NO_MFG_CHOSEN_ERR,
              },
            ])
          );
        } else {
          const reqMailingDataPayload = {
            ...reqRecordMailingData,
            recordMailDateByInvcNum: false,
            mailingDate: getDateInMMDDYYYYFormat(
              reqRecordMailingData.mailingDate
            ),
            invoiceNum: '',
            mfgIdList:
              !reqRecordMailingData.forAllMfg && selected != null
                ? selected
                : null,
            planTypecd: getPlanTypeCd(),
            alreadyHasMailDt: false,
          };
          dispatch(calculateRecordMailingDate(reqMailingDataPayload));
        }
      } else if (
        reqRecordMailingData.defInvoiceSelectModeCd === 'IN' &&
        reqRecordMailingData?.invoiceNum
      ) {
        dispatch(calculateRecordMailingDate(getMailingDataPayload(false)));
      }
    }
  };

  const getPlanTypeCd = () => {
    const { planType } = reqRecordMailingData;
    if (planType === 'FD' || planType === 'ST') {
      return 'G';
    }
    if (planType === 'COMM' || planType === 'SUPP') {
      return 'C';
    }
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows();
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({});
    }
  };

  const getMailingDataPayload = (hasMailingDt) => {
    return {
      ...reqRecordMailingData,
      mailingDate: getDateInMMDDYYYYFormat(reqRecordMailingData.mailingDate),
      mfgIdList:
        !reqRecordMailingData.forAllMfg && selected != null ? selected : null,
      forAllMfg: false,
      invoiceNum: reqRecordMailingData?.invoiceNum,
      alreadyHasMailDt: hasMailingDt,
      recordMailDateByInvcNum:
        reqRecordMailingData.defInvoiceSelectModeCd === 'IN' ? true : false,
    };
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessages || [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'invoiceNum') {
      if (value === null || value === '') {
        localErr = [];
        localErr.push({
          field: 'resultNotFound1',
          errorType: 'invoiceNum',
          message: constantMessageData.INVOICE_NUM_REQ,
        });
      } else {
        localErr = [];
      }
    }
    if (type === 'qtr') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'qtr' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'qtr' && item.field !== 'resultNotFound'
          );

          dispatch(
            setReqRecordMailingData({
              ...reqRecordMailingData,
              qtr: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr = localErr.filter(
            (item) => item.field !== 'qtr' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'qtr',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'qtr' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'qtr',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(setErrorMessages([...new Set(localErr)]));
  };
  // call on Blur event &OnChange even As of date filed level
  const handleOnBlurDateEvent = (d, event) => {
    let localErr = errorMessages || [];
    if (d != 'Invalid Date') {
      let value = null;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value = d.target.value;
        }
      } else {
        value = event === 'onBlur' ? d.target.value : d;
      }
      let showError = false;
      if (value === null || value === '') {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'compareDateGreater' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'mailingDateRequired',
          errorType: 'mailingDate',
          message: constantMessageData.MAILING_DATE_REQUIRED,
        });
        dispatch(
          setReqRecordMailingData({
            ...reqRecordMailingData,
            mailingDate: value,
          })
        );
      } else if (validDate(new Date(value)) === false) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'compareDateGreater' &&
            item.field !== 'mailingDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'dateFormatInvalid',
          errorType: 'mailingDate',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
        dispatch(
          setReqRecordMailingData({
            ...reqRecordMailingData,
            mailingDate: value,
          })
        );
      } else if (compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'mailingDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'compareDateGreater',
          errorType: 'mailingDate',
          message: constantMessageData.MINIMUM_MAILING_DT,
        });
        dispatch(
          setReqRecordMailingData({
            ...reqRecordMailingData,
            mailingDate: value,
          })
        );
      }
      if (!showError) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'compareDateGreater' &&
            item.field !== 'mailingDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        dispatch(
          setReqRecordMailingData({
            ...reqRecordMailingData,
            mailingDate: value,
          })
        );
      }
      dispatch(setErrorMessages([...new Set(localErr)]));
    }
  };
  const [gridApi, setGridApi] = React.useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
    React.useEffect(() => {
      if (!gridApi || manufacturersByPQR === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows?.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
      }
    }, [gridApi, manufacturersByPQR]);
  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        {spinnerLoader && <Spinner load={spinnerLoader} />}
        <CustomSeparator parent1="Invoice" parent2="Record Mailing Date" />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              errorMessages?.filter((x) => {
                if (reqRecordMailingData.defInvoiceSelectModeCd === 'IN') {
                  return (
                    x.errorType === 'invoiceNum' ||
                    x.errorType === 'mailingDate'
                  );
                }
                return x.errorType !== 'invoiceNum';
              })?.length > 0
                ? _.map(
                    errorMessages?.filter((x) => {
                      if (
                        reqRecordMailingData.defInvoiceSelectModeCd === 'IN'
                      ) {
                        return (
                          x.errorType === 'invoiceNum' ||
                          x.errorType === 'mailingDate'
                        );
                      }
                      return x.errorType !== 'invoiceNum';
                    }),
                    (l) => l.message
                  )
                : []
            ),
          ]}
        />
        <DisplaySuccessMessages successMessages={successMessages} />
        <CommonModal
          className="dialog-500"
          data-testid="common-modal-success"
          open={showPopupSuccess}
          viewAction
          viewHeader
          onOk={() => {
            setShowPopupSuccess(false);
          }}
          onClose={() => {
            setShowPopupSuccess(false);
          }}
          okTitle="OK"
          modalTitle="Record Mailing Date"
          childrenComponent={<div className="p-3">{successMessages[0]}</div>}
        />
        <CommonModal
          className="dialog-500"
          data-testid="common-modal-warning"
          open={showPopup}
          viewAction
          viewHeader
          onOk={() => {
            dispatch(calculateRecordMailingDate(getMailingDataPayload(true)));
            setShowPopup(false);
          }}
          onClose={() => {
            setShowPopup(false);
          }}
          okTitle="Yes"
          closeTitle="No"
          modalTitle="Record Mailing Date"
          childrenComponent={<div className="p-3">{popupMessage}</div>}
        />
        {!fullScreenView && (
          <>
            <div className="panel mb-3">
              <div className="row">
                <div className="col-sm-8">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family" id="select_by_label">
                      Select by<span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="select_by_label"
                              name="defInvoiceSelectModeCd"
                              value={
                                reqRecordMailingData.defInvoiceSelectModeCd ||
                                'PQM'
                              }
                              onChange={handlereqRecordMailingData}
                            >
                              <FormControlLabel
                                style={{ marginRight: '10px' }}
                                value="PQM"
                                label="Program/Quarter"
                                data-test="Program/Quarter"
                                control={<Radio />}
                              />
                              <FormControlLabel
                                style={{ marginRight: '10px' }}
                                value="IN"
                                label="Invoice Number"
                                data-test="Invoice Number"
                                control={<Radio />}
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend
                      className="same-font-family"
                      id="begindate-picker-dialog-label"
                    >
                      Mailing Date<span className="mandatory"> *</span>{' '}
                    </legend>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <KeyboardDatePicker
                          data-test="start-date"
                          id="begindate-picker-dialog"
                          format="MM/dd/yyyy"
                          placeholder="mm/dd/yyyy"
                          name="mailingDate"
                          className="mandate-fields MuiInput-root.Mui-error"
                          invalidDateMessage={[
                            errorConstant.DATE_INVALID_FORMAT_ERROR,
                          ]}
                          value={
                            mailingDate && getUTCTimeStampMMDDYYYY(mailingDate)
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            'aria-labelledby': 'begindate-picker-dialog-label',
                          }}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          onChange={(e) => {
                            handleDate(e, 'mailingDate');
                          }}
                          onBlur={(e) => {
                            handleOnBlurDateEvent(e, 'onBlur');
                          }}
                          onKeyDown={async (e) => {
                            if (e.keyCode == 67) {
                              // copy date
                              await window.navigator?.clipboard.writeText(
                                e?.target?.value
                              );
                            }
                          }}
                          helperText={
                            errorMessages?.length > 0
                              ? [
                                  ...new Set(
                                    errorMessages
                                      ?.filter((x) => {
                                        return (
                                          x.field === 'compareDateGreater' ||
                                          x.field === 'mailingDateRequired' ||
                                          x.field === 'dateFormatInvalid'
                                        );
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : null
                          }
                          error={
                            errorMessages?.length > 0 &&
                            errorMessages?.filter((x) => {
                              return (
                                x.field === 'compareDateGreater' ||
                                x.field === 'mailingDateRequired' ||
                                x.field === 'dateFormatInvalid'
                              );
                            }).length > 0
                              ? [
                                  ...new Set(
                                    errorMessages
                                      ?.filter((x) => {
                                        return (
                                          x.field === 'compareDateGreater' ||
                                          x.field === 'mailingDateRequired' ||
                                          x.field === 'dateFormatInvalid'
                                        );
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : false
                          }
                        />
                      </div>
                    </MuiPickersUtilsProvider>
                  </fieldset>
                </div>
              </div>

              {reqRecordMailingData.defInvoiceSelectModeCd === 'PQM' && (
                <div className="row">
                  <div className="col-sm-4">
                    <RadioGroupComponent
                      data-testid="filter-plan-by-radio-btn-plan"
                      id="filter-plan-by-radio-btn-action"
                      labelName={radioGroupLabelNamePlan}
                      required
                      applyStyle
                      reqColor
                      optionList={planTypeOptions}
                      defaultValue={reqRecordMailingData?.planType}
                      filterAction={(e) => {
                        handlereqRecordMailingData({
                          target: {
                            name: 'planType',
                            value: e,
                          },
                        });
                      }}
                      className="log-batch-filter-radio"
                    />
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Rebate Program<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            label="Rebate Program"
                            fullWidth
                            select
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'rebateProgramCd',
                            }}
                            required
                            onChange={handlereqRecordMailingData}
                            id="rebateProgramCd"
                            name="rebateProgramCd"
                            value={reqRecordMailingData?.rebateProgramCd}
                            onBlur={(e) =>
                              handleOnblurEvent(
                                'rebateProgramCd',
                                e.target.value
                              )
                            }
                            className={
                              errorMessages?.length > 0
                                ? _.map(errorMessages, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              errorMessages?.length > 0
                                ? _.map(errorMessages, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            error={
                              errorMessages?.length > 0
                                ? _.map(errorMessages, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {Array.isArray(rebateProgramList) &&
                              rebateProgramList.map((item) => (
                                <MenuItem
                                  key={item.rebateProgramCd}
                                  value={item.rebateProgramCd}
                                  className="frr-logcheck-dropdown-item"
                                >
                                  {item.rebateProgramCd} | {item.shortDescr}
                                </MenuItem>
                              ))}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Quarter<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            label="Quarter"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 6 }}
                            required
                            id="qtr"
                            name="qtr"
                            value={reqRecordMailingData?.qtr}
                            onChange={handlereqRecordMailingData}
                            onBlur={(e) =>
                              handleOnblurEvent('qtr', e.target.value)
                            }
                            className={
                              errorMessages?.length > 0
                                ? _.map(errorMessages, (l) =>
                                    l.field === 'qtr' ? 'mandate-fields' : null
                                  )
                                : null
                            }
                            helperText={[
                              ...new Set(
                                errorMessages?.length > 0
                                  ? _.map(errorMessages, (l) =>
                                      l.field === 'qtr' ? l.message : null
                                    )
                                  : null
                              ),
                            ]}
                            error={[
                              ...new Set(
                                errorMessages?.length > 0
                                  ? _.map(errorMessages, (l) =>
                                      l.field === 'qtr' ? l.message : null
                                    )
                                  : null
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
              <div className="row">
                {reqRecordMailingData.defInvoiceSelectModeCd === 'IN' && (
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Invoice Number<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            label="Invoice Number"
                            fullWidth
                            required
                            placeholder=""
                            value={reqRecordMailingData?.invoiceNum}
                            id="invoiceNum"
                            name="invoiceNum"
                            // inputProps={{ maxlength: 11 }}
                            onChange={handlereqRecordMailingData}
                            onKeyPress={isNumber}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 38 }}
                            onBlur={(e) =>
                              handleOnblurEvent('invoiceNum', e.target.value)
                            }
                            className={
                              errorMessages?.length > 0
                                ? _.map(errorMessages, (l) =>
                                    l.errorType === 'invoiceNum'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            helperText={[
                              ...new Set(
                                errorMessages?.length > 0
                                  ? _.map(errorMessages, (l) =>
                                      l.errorType === 'invoiceNum'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              ),
                            ]}
                            error={[
                              ...new Set(
                                errorMessages?.length > 0
                                  ? _.map(errorMessages, (l) =>
                                      l.errorType === 'invoiceNum'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                {reqRecordMailingData.defInvoiceSelectModeCd === 'PQM' && (
                  <div className="col-sm-4">
                    <div
                      className="mui-custom-form with-select min-md"
                      style={{ width: '100%' }}
                    >
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              name="forAllMfg"
                              checked={reqRecordMailingData?.forAllMfg}
                               onChange={(e) => {
                                handlereqRecordMailingData(e);
                                   if (!e.target.checked) {
                                    searchManufacturers();
                                  }
                              }}
                            />
                          }
                          label="All Manufacturers"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-8">
                  <div className="btn-wrapper mb-2">
                    <div className="float-right mt-2 hide-on-print">
                      {reqRecordMailingData.defInvoiceSelectModeCd ===
                        'PQM' && (
                        <Button
                          className="btn-success same-font-family frr-btn-width-17 mt-4"
                          onClick={searchManufacturers}
                        >
                          <SVGComponent iconName="Icon-search" /> Search
                        </Button>
                      )}

                      <Button
                        className="btn-success same-font-family frr-btn-width-17 mt-4"
                        onClick={processRecordMailingDate}
                      >
                        <SVGComponent iconName="Create-new-icon" /> Process
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="clearfix" />
      </div>
      {!reqRecordMailingData?.forAllMfg &&
        reqRecordMailingData.defInvoiceSelectModeCd === 'PQM' && (
          <div className="panel tBillPanel-space pb-0">
            <div className="FRR-custom-table tbl-manufacturer-home">
              <Grid
                gridHeight={fullScreenView ? '100vh' : 350}
                headerHeight={headerHeight}
                rowData={Array.isArray(manufacturersByPQR) ? manufacturersByPQR : []}
                columnDefs={manuFactureHeadRecordMailing}
                data-testid="onEditingStopped"
                gridCall={onGridReady}
                enterMovesDown
                getRowStyle={getRowStyle}
                onCellFocused={onCellFocused}
                singleClickEdit={false}
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                handleFullScreenViewClick={handleFullScreenViewClick}
                exportFile
                onSelect={onCellClicked}
                fileName="Record Mailing Date"
                //handleViewHistory={handleViewHistory}
              />
            </div>
            {showViewHistory ? (
              <ViewHistoryComponent
                setShowViewHistory={setShowViewHistory}
                tableName="RECORD_MAILING"
                keyValue={keyValue}
              />
            ) : null}
          </div>
        )}
    </div>
  );
}
export default withRouter(RecordMailingDate);
